import { LockOutlined } from '@duxton-web/icons';
import {
  Drawer, Flex, Tag, Typography,
} from '@duxton-web/ui';
import { cpListAttributes } from 'omega-rtc/actions/ucd';
import React, { useState } from 'react';

import { attributeFromApi, localeSorter } from './adapters';
import EntityListPage, { useEntityList } from './EntityListPage';

const columns = [
  {
    title: 'Key',
    dataIndex: 'key',
    width: '32%',
    sorter: localeSorter('key'),
    render: (key) => <Tag>{key}</Tag>,
  },
  {
    title: 'Description',
    dataIndex: 'definition',
    render: (d) => <Typography.Body level={2} type="secondary">{d}</Typography.Body>,
  },
];

const AttrsPage = () => {
  const { data: attrs, loading } = useEntityList(
    cpListAttributes, 'ucd.cpAttributes', 'requests.cpListAttributesRequest', attributeFromApi,
  );
  const [open, setOpen] = useState(null);

  return (
    <EntityListPage
      title="User Attributes"
      rowKey="key"
      columns={columns}
      data={attrs}
      loading={loading}
      searchable
      searchPlaceholder="Search attributes…"
      searchFields={['key', 'definition']}
      emptyText="No attributes match."
      onRowClick={setOpen}
    >
      <Drawer
        title={
          open ? (
            <Flex align="center" gap={10}>
              <Typography.Title level={5}>{open.key}</Typography.Title>
              <Tag icon={<LockOutlined />}>View-only</Tag>
            </Flex>
          ) : null
        }
        width={520}
        open={Boolean(open)}
        onClose={() => setOpen(null)}
        destroyOnClose
      >
        {open && (
          <Flex vertical gap="small">
            <Typography.Metadata type="secondary">
              USER ATTRIBUTE · DS API PROXY
            </Typography.Metadata>
            <Typography.Paragraph>
              {open.definition}
            </Typography.Paragraph>
            {open.remarks ? (
              <React.Fragment>
                <Typography.Body strong>Remarks</Typography.Body>
                <Typography.Paragraph className="cc-pre-line">
                  {open.remarks}
                </Typography.Paragraph>
              </React.Fragment>
            ) : null}
            <Typography.Metadata type="secondary">
              Sourced from the external DS API. Not stored in content_config; managed upstream.
            </Typography.Metadata>
          </Flex>
        )}
      </Drawer>
    </EntityListPage>
  );
};

export default AttrsPage;
